import { camelCaseToTitleCase } from "util/helper/helper";
import HideIf from "util/HideIf";

const PATFitmentNote = (props) => {
  const { fitmentNote } = props;
  const { fittingSubModels, specification, ...restParams } = fitmentNote;
  const fitmentNoteKeys = Object.keys(restParams || {});
  const specificationKeys = Object.keys(specification || {});
  return (
    <li>
      <HideIf show={fittingSubModels?.length}>
        <span>Sub Models: </span>
        <span>{`${fittingSubModels.join(", ")}; `}</span>
      </HideIf>
      {fitmentNoteKeys.map((key) => {
        if (restParams[key]) {
          return (
            <>
              <span>{`${camelCaseToTitleCase(key)}: `}</span>
              <span>{`${restParams[key]}; `}</span>
            </>
          );
        }
        return null;
      })}
      {specificationKeys.map((key) => {
        if (specification[key]) {
          return (
            <>
              <span>{`${camelCaseToTitleCase(key)}: `}</span>
              <span>{`${specification[key]}; `}</span>
            </>
          );
        }
        return null;
      })}
    </li>
  );
};

export default PATFitmentNote;
